<ng-template #formContent>
  @if( !!isAnchor ) {
  <a matAnchor target='xxx' [href]='props?.placeholder'>{{props?.description}}</a>
  }
  <div [align]="props?.align ?? 'start'" [class]='field.fieldGroupClassName'>
    <ng-container #fieldComponent></ng-container>
    @if( !!props?.searchList) {
    <div class='flex-full' align='right'>
      <input hidden="true" aria-hidden="true" matInput matAutocompleteTriggerRestoreFocus=true
        [matAutocomplete]="searchList" [matAutocompleteConnectedTo]="origin">
      <img align='right' alt="{{props.placeholder}}" src="/assets/google_on_white.png" matAutocompleteOrigin
        #origin="matAutocompleteOrigin">
    </div>
    }
  </div>
  @if ( props.resetButton?.enabled ) {
  <button mat-flat-button type="button" (click)="resetGroup()" color="accent">{{props.resetButton?.label ?? "Reset Form"}}</button>
  }

  <mat-autocomplete #searchList='matAutocomplete' class="mutara-search-box"
    [panelWidth]="'auto'" aria-label="Available values">
    <h4 mat-memu-item class="mutara-search-title">Search Results</h4>
    @for ( searchItem of searchItems; track searchItem; let idx = $index;) {
    <mat-option [value]="searchItem" (click)="selectSearchItem(idx)">{{searchItem}}</mat-option>
    }
  </mat-autocomplete>
</ng-template>

<ng-template #formTitle>
  @if ( !!props?.icon ) {
  <mat-icon class='mutara-icon'>{{props.icon}}</mat-icon>
  }
  <h2 class="mat-headline-2">{{props.label}}</h2>
  @if ( !props?.inLineHint ) {
  @if ( !!props.description ) {
  <mat-icon class='flex-end' [matMenuTriggerFor]="info">info</mat-icon>
  <mat-menu #info>
    <mat-menu-item><markdown>{{props.description}}</markdown></mat-menu-item>
  </mat-menu>
  }
  } @else if ( !!props.description) {
  <markdown class="mutara-tb-margin mutara-tb-pad">{{props.description}}</markdown>
  }
</ng-template>

@if (!props?.collapseEnabled ) {
<section [class]="{'mutara-expansion-panel': true,  'mutara-display-none'  : field.hide}">
  @if ( !!props.label || !!props.description ) {
  <div class="mutara-expansion-panel-header always-flex">
    <ng-template [ngTemplateOutlet]="formTitle"></ng-template>
  </div>
  }
  @if( visibleChildren ) {
  <div class='mutara-expansion-panel-content'>
    <ng-template [ngTemplateOutlet]="formContent"></ng-template>
  </div>
  }
</section>
} @else {
<section [class]="{'lr-pad': true,  'mutara-display-none'  : field.hide}">
  <mat-expansion-panel [expanded]="!!props?.defaultOpen" [class]="'mutara-expansion-panel'">
    @if ( !!props?.label || !!props?.description ) {
    <mat-expansion-panel-header [class]="['mutara-expansion-panel-header', 'lr-pad', props.viewStyle ?? '']">
      <mat-panel-title class="flex-full">
        <ng-template [ngTemplateOutlet]="formTitle"></ng-template>
      </mat-panel-title>
    </mat-expansion-panel-header>
    }
    <mat-expansion-panel-content [class]="['mutara-expansion-panel-content','lr-pad']">
      <ng-template [ngTemplateOutlet]="formContent"></ng-template>
    </mat-expansion-panel-content>
  </mat-expansion-panel>
</section>
}